import React from 'react';
import { AlkmaarSkyline } from './AlkmaarSkyline';
import { ArrowRightIcon } from 'lucide-react';
export function LocalAuthoritySection() {
  const scrollToContact = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('contact')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="regio" className="relative py-24 lg:py-28 bg-white overflow-hidden" data-id="element-691" data-mp="312l226u3p7jo">
      {/* Skyline background */}
      <div className="absolute bottom-0 left-0 right-0 opacity-30 pointer-events-none" data-id="element-692" data-mp="3ot75tlx2o5nv">
        <AlkmaarSkyline className="w-full h-auto" color="#9FB3C8" data-id="element-693" data-mp="3tpe1mlvr80s3" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-694" data-mp="3f0hv4t9civtl">
        <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 text-center mb-8" data-id="element-695" data-mp="3jzm71rnnn7nm">
          Webdesign bureau in Alkmaar en omgeving
        </h2>

        <div className="max-w-3xl mx-auto" data-id="element-696" data-mp="bihnjf7pcsgi">
          <p className="text-lg text-navy-700 leading-relaxed text-center mb-6" data-id="element-697" data-mp="gbki9qo7u7ya">
            Als specialist in <strong data-id="element-698" data-mp="4bdyyjjy8kaj">webdesign in Alkmaar</strong> helpen wij
            lokale ondernemers met professionele websites die écht werken. Of je
            nu een <strong data-id="element-699" data-mp="3vgdplx10df1s">website wilt laten maken in Alkmaar</strong>, op zoek
            bent naar een <strong data-id="element-700" data-mp="d6266f934c1z">WordPress specialist in Alkmaar</strong>, of
            je <strong data-id="element-701" data-mp="8dinj3vjiqqb">online zichtbaarheid in Alkmaar</strong> wilt verbeteren
            — wij staan voor je klaar.
          </p>
          <p className="text-base text-navy-600 leading-relaxed text-center mb-10" data-id="element-702" data-mp="n13sz4fw121e">
            Wij werken voor ondernemers in <strong data-id="element-703" data-mp="i5oh2i1fxg7m">Alkmaar</strong>,{' '}
            <strong data-id="element-704" data-mp="w3v4t5codztk">Bergen</strong>, <strong data-id="element-705" data-mp="w21y5q22bflk">Heiloo</strong>,{' '}
            <strong data-id="element-706" data-mp="w10n3ll1qt3u">Heerhugowaard</strong>, <strong data-id="element-707" data-mp="s18bt149q8us">Castricum</strong>,{' '}
            <strong data-id="element-708" data-mp="s29pldco59g7">Langedijk</strong> en de rest van de regio Noord-Holland
            Noord. Met onze kennis van de lokale markt zorgen wij ervoor dat
            jouw bedrijf online opvalt bij klanten in de buurt.
          </p>

          <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-709" data-mp="wsi8f9atryo3">
            Of je nu een nieuwe website wilt laten maken, beter gevonden wilt
            worden in Google, of je huidige website wilt vernieuwen en
            verbeteren. Wij staan voor je klaar.
          </p>

          {/* Internal links - SEO Silo */}
          <div className="flex flex-wrap items-center justify-center gap-3 mb-10" data-id="element-710" data-mp="1bqaoq3o74r3c">
            <a href="#/webdesign-alkmaar" className="inline-flex items-center gap-1.5 bg-accent-light text-accent font-medium text-sm px-4 py-2 rounded-full hover:bg-accent hover:text-white transition-all duration-200" data-id="element-711" data-mp="1frmdk6z8x8ah">
              Webdesign Alkmaar
              <ArrowRightIcon className="w-3.5 h-3.5" data-id="element-712" data-mp="1ug91uy6upadu" />
            </a>
            <a href="#/webdesign-heerhugowaard" className="inline-flex items-center gap-1.5 bg-accent-light text-accent font-medium text-sm px-4 py-2 rounded-full hover:bg-accent hover:text-white transition-all duration-200" data-id="element-713" data-mp="1uibsnkftv7jm">
              Webdesign Heerhugowaard
              <ArrowRightIcon className="w-3.5 h-3.5" data-id="element-714" data-mp="3nwvdyzgoqab5" />
            </a>
            <a href="#/webdesign-hoorn" className="inline-flex items-center gap-1.5 bg-accent-light text-accent font-medium text-sm px-4 py-2 rounded-full hover:bg-accent hover:text-white transition-all duration-200" data-id="element-715" data-mp="3jvt9a340161s">
              Webdesign Hoorn
              <ArrowRightIcon className="w-3.5 h-3.5" data-id="element-716" data-mp="bg9kbgad29sj" />
            </a>
            <a href="#/webdesign-schagen" className="inline-flex items-center gap-1.5 bg-accent-light text-accent font-medium text-sm px-4 py-2 rounded-full hover:bg-accent hover:text-white transition-all duration-200" data-id="element-717" data-mp="6hyb97rw43bd">
              Webdesign Schagen
              <ArrowRightIcon className="w-3.5 h-3.5" data-id="element-718" data-mp="u7sovrk19vwo" />
            </a>
            <a href="#/webdesign-den-helder" className="inline-flex items-center gap-1.5 bg-accent-light text-accent font-medium text-sm px-4 py-2 rounded-full hover:bg-accent hover:text-white transition-all duration-200" data-id="element-719" data-mp="u9vlwvjlspaw">
              Webdesign Den Helder
              <ArrowRightIcon className="w-3.5 h-3.5" data-id="element-720" data-mp="dyl3t2uwitz7" />
            </a>
            <a href="#/website-laten-maken-alkmaar" className="inline-flex items-center gap-1.5 bg-accent-light text-accent font-medium text-sm px-4 py-2 rounded-full hover:bg-accent hover:text-white transition-all duration-200" data-id="element-721" data-mp="2pqdcj9ub37">
              Website laten maken Alkmaar
              <ArrowRightIcon className="w-3.5 h-3.5" data-id="element-722" data-mp="xo3zihm2h0cq" />
            </a>
          </div>

          <div className="text-center" data-id="element-723" data-mp="izhga4tbjog8">
            <a href="#contact" onClick={scrollToContact} className="inline-flex items-center gap-2 bg-accent hover:bg-accent-hover text-white font-semibold px-8 py-4 rounded-button shadow-medium hover:shadow-card transition-all duration-200 text-base group" data-id="element-724" data-mp="nz3sqc1bp0nz">
              Neem contact op
              <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-200" data-id="element-725" data-mp="314imcp4ojx8u" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}